import { useFieldArray, useFormContext, useWatch } from "react-hook-form";
import JobReferencesFieldArray from "./JobReferencesFieldArray";
import CountrySelect from "./CountrySelect";

export function JobExperienceDataTab() {
  const {
    register,
    setValue,
    formState: { errors },
  } = useFormContext();

  const {
    fields: fieldsExperience,
    append: appendExperience,
    remove: removeExperience,
  } = useFieldArray({ name: "jobExperiences" });
  const addJobExperience = () => {
    appendExperience({});
  };

  const removeJobExperience = (index) => {
    removeExperience(index);
  };
  const jobExperiences = useWatch({
    name: "jobExperiences",
  });

  return (
    <div className="c-profile-info__switchable js-switchable" data-content="3">
      <h3 className="u-hidden-for-seo">Experiencia</h3>
      <p className="c-profile-info__intro u-text" style={{ marginBottom: '24px' }}>¿Que colocar aquí? Aquí debo colocar mi experiencia de trabajo, puede ser formal ó informal. Deben ser referencias a las que podamos contactar. Si no tienes experiencia previa, puedes indicar un docente u otra figura de referencia. Si realizaste tareas de voluntariado, también suma.</p>
      <div className="c-form__row c-form__row--2col">
      <div className="c-form__row">

        <span className="c-form__label c-form__label--mb">
          ¿Primera experiencia laboral?
        </span>
        <label
          className="c-form__radio u-tap-size"
          htmlFor={`first-experience-yes`}
        >
          <input
            className="c-form__radio-input"
            type="radio"
            id={`first-experience-yes`}
            name="firstExperience"
            value="1"
            {...register(`firstExperience`)}
          />
          <span className="c-form__radio-btn"></span>
          <span className="c-form__label c-form__label--radio">Si</span>
        </label>
        <label
          className="c-form__radio u-tap-size"
          htmlFor={`first-experience-no`}
        >
          <input
            className="c-form__radio-input"
            type="radio"
            id={`first-experience-no`}
            name="firstExperience"
            defaultChecked={true}
            value="0"
            {...register(`firstExperience`)}
          />
          <span className="c-form__radio-btn"></span>
          <span className="c-form__label c-form__label--radio">No</span>
        </label>
        </div>
      </div>
      {/* <!-- SEPARATOR --> */}
      <div className="c-profile-info__separator"></div>
      {/* <!-- EMPLEO 1 --> */}
      {fieldsExperience?.map((job, index) => {
        return (
          <div
            key={`jobExperiences-${index}`}
            className="c-profile-info__section c-form__section"
          >
            <h2 className="c-form__title">Empleo #{index + 1}</h2>
            <div className="c-form__editable-title">
              <label className="c-form__group">
                <label className="c-form__group">
                  <span className="c-form__label">
                    Indique el nombre de la empresa
                  </span>
                  <input
                    type="text"
                    name={`jobExperiences.${index}.companyName`}
                    className="c-form__input"
                    placeholder="Nombre de la empresa"
                    {...register(`jobExperiences.${index}.companyName`, {
                      required: true,
                    })}
                  />
                </label>
              </label>
              {errors?.jobExperiences &&
                errors?.jobExperiences[index]?.companyName?.type ===
                  "required" && (
                  <span className="c-form__error">
                    Este campo es obligatorio
                  </span>
                )}
              {/* <button type="button" className="c-form__editable-title-btn icon-edit"></button> */}
            </div>
            <CountrySelect
              label="País"
              register={register}
              setValue={setValue}
              errors={errors}
              countryPath={`jobExperiences.${index}.location.country`}
              otherCountryPath={`jobExperiences.${index}.location.other`}
              cityPath={`jobExperiences.${index}.location.city`}
              selectedCountry={jobExperiences[index]?.location?.country}
            />
            <div className="c-form__row c-form__row--2col">
              <div className="c-form__col">
                <span className="c-form__label c-form__label--mb">
                  Trabajando actualmente en la empresa{" "}
                </span>
                <label
                  className="c-form__radio u-tap-size"
                  htmlFor={`2-trabajando-si-${index}`}
                >
                  <input
                    className="c-form__radio-input"
                    type="radio"
                    id={`2-trabajando-si-${index}`}
                    name="isCurrentlyWorking"
                    value="1"
                    onClick={() => {
                      setValue(`jobExperiences.${index}.endDate`, "");
                    }}
                    {...register(`jobExperiences.${index}.isCurrentlyWorking`)}
                  />
                  <span className="c-form__radio-btn"></span>
                  <span className="c-form__label c-form__label--radio">Si</span>
                </label>
                <label
                  className="c-form__radio u-tap-size"
                  htmlFor={`2-trabajando-no-${index}`}
                >
                  <input
                    className="c-form__radio-input"
                    type="radio"
                    id={`2-trabajando-no-${index}`}
                    name="isCurrentlyWorking"
                    value="0"
                    onClick={() => {
                      setValue(`jobExperiences.${index}.endDate`, "");
                    }}
                    {...register(`jobExperiences.${index}.isCurrentlyWorking`)}
                  />
                  <span className="c-form__radio-btn"></span>
                  <span className="c-form__label c-form__label--radio">No</span>
                </label>
              </div>
              <div className="c-form__col c-form__row c-form__row--2col">
                <label className="c-form__group c-form__col">
                  <span className="c-form__label">Fecha de comienzo </span>
                  <input
                    type="date"
                    id="form-begin-date"
                    name="form-begin-date"
                    className="c-form__input c-form__input--small"
                    {...register(`jobExperiences.${index}.startDate`, {
                      required: true,
                    })}
                  />
                  {errors?.jobExperiences &&
                    errors?.jobExperiences[index]?.startDate?.type ===
                      "required" && (
                      <span className="c-form__error">
                        Este campo es obligatorio
                      </span>
                    )}
                </label>
                {jobExperiences[index]?.isCurrentlyWorking === "0" && (
                  <label className="c-form__group c-form__col">
                    <span className="c-form__label">
                      Fecha de finalización{" "}
                    </span>
                    <input
                      type="date"
                      id="form-end-date"
                      name="form-end-date"
                      className="c-form__input c-form__input--small"
                      {...register(`jobExperiences.${index}.endDate`, {
                        required: true,
                      })}
                    />
                    {errors?.jobExperiences &&
                      errors?.jobExperiences[index]?.endDate?.type ===
                        "required" && (
                        <span className="c-form__error">
                          Este campo es obligatorio
                        </span>
                      )}
                  </label>
                )}
              </div>
            </div>
            <div className="c-form__row c-form__row--2col">
              <div className="c-form__row">
                <span className="c-form__label c-form__label--mb">
                  ¿Tenía personas a cargo?
                </span>
                <label
                  className="c-form__radio u-tap-size"
                  htmlFor={`personas-a-cargo-si-${index}`}
                >
                  <input
                    className="c-form__radio-input"
                    type="radio"
                    id={`personas-a-cargo-si-${index}`}
                    name="peopleInCharge"
                    value="1"
                    {...register(`jobExperiences.${index}.peopleInCharge`)}
                  />
                  <span className="c-form__radio-btn"></span>
                  <span className="c-form__label c-form__label--radio">Si</span>
                </label>
                <label
                  className="c-form__radio u-tap-size"
                  htmlFor={`personas-a-cargo-no-${index}`}
                >
                  <input
                    className="c-form__radio-input"
                    type="radio"
                    id={`personas-a-cargo-no-${index}`}
                    name="peopleInCharge"
                    defaultChecked={true}
                    value="0"
                    {...register(`jobExperiences.${index}.peopleInCharge`)}
                  />
                  <span className="c-form__radio-btn"></span>
                  <span className="c-form__label c-form__label--radio">No</span>
                </label>
              </div>
            </div>
            <div className="c-form__row">
              <label className="c-form__group">
                <span className="c-form__label">
                  Cargo que{" "}
                  {jobExperiences[index]?.isCurrentlyWorking === "0"
                    ? "ocupaba"
                    : "ocupa"}
                </span>
                <textarea
                  name="description"
                  rows="1"
                  className="c-form__input c-form__input--textarea"
                  placeholder={`Ingresa el cargo que ${
                    jobExperiences[index]?.isCurrentlyWorking === "0"
                      ? "ocupaba"
                      : "ocupa"
                  } en la empresa...`}
                  {...register(`jobExperiences.${index}.charge`, {
                    required: true,
                  })}
                ></textarea>
                {errors?.jobExperiences &&
                  errors?.jobExperiences[index]?.charge?.type ===
                    "required" && (
                    <span className="c-form__error">
                      Este campo es obligatorio
                    </span>
                  )}
              </label>
            </div>
            <div className="c-form__row">
              <label className="c-form__group">
                <span className="c-form__label">Cargo a quien reportaba</span>
                <textarea
                  name="description"
                  rows="1"
                  className="c-form__input c-form__input--textarea"
                  placeholder="Ingresa el nombre la persona a quien reportaba..."
                  {...register(`jobExperiences.${index}.reportTo`)}
                ></textarea>
              </label>
            </div>
            <h5 className="c-form__subtitle">Referencias laborales</h5>
            <JobReferencesFieldArray
              nestIndex={index}
              {...{ register }}
              setValue={setValue}
              errors={errors}
            />

            <button
              type="button"
              onClick={() => removeJobExperience(index)}
              className="c-form__btn c-form__btn-delete c-form__btn c-form__btn-delete--top u-tap-size"
            >
              <span className="c-form__btn-icon icon-delete"></span>Eliminar
              empleo
            </button>
            {/* <!-- SEPARATOR --> */}
            <div className="c-profile-info__separator"></div>
          </div>
        );
      })}

      {/* <!-- AÑADIR OTRO EMPLEO --> */}
      <button
        type="button"
        onClick={addJobExperience}
        className="c-form__btn-add--xl"
      >
        <span className="c-form__btn-add-icon c-form__btn-add-icon--xl icon-more"></span>
        Añadir otro empleo
      </button>
    </div>
  );
}
